import { Component, Input } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { Paystub } from '@app/models/payroll/company/paystub.model';
import { Payroll } from '@app/models/payroll/payroll.model';
import { AnalyticService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { PaystubLazyLoadService } from '@payroll/services';

type PayrollReviewDialogType = 'PAYSTUB_DETAILS' | 'OTHER_REMITTANCES';

@Component({
    selector: 'app-form-payroll-review',
    templateUrl: './payroll-review.template.html',
    styleUrls: ['./payroll-review.style.scss'],
})
export class PayrollReviewForm extends BaseForm {
    @Input({ required: true }) payroll!: Payroll;
    activePaystub?: Paystub;
    currentlyOpenDialog?: PayrollReviewDialogType;

    constructor(
        private analytics: AnalyticService,
        public paystubService: PaystubLazyLoadService
    ) {
        super();
    }

    get showQcRemittances(): boolean {
        return this.payroll.hasQcRemittances;
    }

    showRecord(paystub: Paystub): void {
        this.activePaystub = paystub;

        this.analytics.trackEvent(AnalyticEvents.PayrollRecurringPayrollReviewStepExpandEmployee);

        this.currentlyOpenDialog = 'PAYSTUB_DETAILS';
    }

    closeDialog(): void {
        this.currentlyOpenDialog = undefined;
    }
}
